import { useLayoutEffect, useState } from 'react';

export const useOnResize = (delay = 100) => {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    let timer;

    setWidth(window.innerWidth);

    const updateWidth = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
      }, delay);
    };

    window.addEventListener('resize', updateWidth);

    return () => window.removeEventListener('resize', updateWidth);
  });

  return [width, height];
};
